const seamapiJavascriptHttpVersion = '1.95.1';
export default seamapiJavascriptHttpVersion;
//# sourceMappingURL=version.js.map